// featureFlagServiceSingleton.js or .ts
import config from '../../utilities/config';
import { FeatureFlagWebSocketService } from './FeatureFlagWebSocketService ';

const configuration = {
    apiBaseUrl: config.api.featureFlag,
    notificationsUrl: config.notifications.featureFlagNotificationsHub,
    isProduction: !config.debug
};

// Create a single instance of the FeatureFlagWebSocketService
const instance = new FeatureFlagWebSocketService(configuration);

export default instance;
